import { useParams } from 'react-router-dom'

import FlowPage from 'modules/contracts/components/FlowPage'
import employees from 'modules/employees/store/collections/employees'

const RootFlowPage = () => {
  const params = useParams()
  const employee = employees.get(Number(params.id))

  return <FlowPage employee={employee!} />
}

export default RootFlowPage
